import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { screenReaderOnly } from '../../app-kit/helpers/screenReaderOnly';
import { spacingHelper } from '@property.com.au/ui-kit';
import startRatingUnderStar from '../../assets/star-rating/under-star.svg';
import startRatingOverStar from '../../assets/star-rating/over-star.svg';

export const StarBoxWrapper = styled.div`
  width: 80px;
  height: 16px;
  position: relative;
  margin-right: ${spacingHelper('twoExtraSmall')};
`;

export const StarsInactive = styled.div`
  width: 80px;
  height: 16px;
  background-image: url(${startRatingUnderStar});
  background-repeat: no-repeat;
  background-size: cover;
`;

export const StarsActive = styled.div<{ $percentage: number }>`
  height: 16px;
  width: ${(props) => props.$percentage}%;
  background-image: url(${startRatingOverStar});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
`;
export const AccessibilityHiddenText = styled.span`
  ${screenReaderOnly}
`;

export const StarFigure = styled.figure`
  display: flex;
`;
export interface StarsProps {
  percentage: number;
}

export interface StarRatingProps extends StarsProps {
  accessibilityText: string;
}

export const Stars: FunctionComponent<StarsProps> = ({ percentage }) => {
  return (
    <StarBoxWrapper role="presentation">
      <StarsActive $percentage={percentage}> </StarsActive>
      <StarsInactive />
    </StarBoxWrapper>
  );
};

// figcaption tag cannot be nested in a <p> element
export const StarRating: FunctionComponent<PropsWithChildren<StarRatingProps>> = ({
  accessibilityText,
  percentage,
  children,
}) => {
  return (
    <StarFigure>
      {percentage > 0 && <Stars percentage={percentage} />}
      {children}
      <figcaption>
        {accessibilityText && (
          <AccessibilityHiddenText>{accessibilityText}</AccessibilityHiddenText>
        )}
      </figcaption>
    </StarFigure>
  );
};
